var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGbFlag = function SvgGbFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .gbflag-cls-1 {\n        fill: #fff;\n      }\n\n      .gbflag-cls-2 {\n        fill: #df0914;\n      }\n\n      .gbflag-cls-3 {\n        fill: none;\n        stroke: #27275b;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .gbflag-cls-4 {\n        fill: #27275b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "gbflag-cls-1",
    x: 2,
    y: 2,
    width: 92.55,
    height: 61.62,
    rx: 10.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-2",
    points: "93.69 28.19 52.9 28.19 52.9 3.01 43.65 3.01 43.65 28.19 2.86 28.19 2.86 37.43 43.65 37.43 43.65 62.11 52.9 62.11 52.9 37.43 93.69 37.43 93.69 28.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "gbflag-cls-2",
    points: "36.84 39.83 6.28 59.58 8.72 62.29 41.41 39.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-2",
    points: "30.85 25.8 4.61 8.62 6.61 5.62 36.86 25.8 36.86 25.8 30.85 25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-2",
    points: "61.04 25.14 90.39 5.86 86.61 3.62 54.86 25.14 54.86 25.14 61.04 25.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-2",
    points: "67.6 39.5 92.61 55.62 91.61 59.62 61.59 39.5 61.59 39.5 67.6 39.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "gbflag-cls-3",
    x: 2,
    y: 2,
    width: 92.55,
    height: 61.62,
    rx: 10.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "41.2 42.14 41.2 61.95 11.81 61.95 41.2 42.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "41.2 23.4 41.2 3.59 11.81 3.59 41.2 23.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "54.9 23.4 54.9 3.59 84.28 3.59 54.9 23.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "54.9 41.97 54.9 61.78 84.28 61.78 54.9 41.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "3.48 10.77 3.48 26.04 27.08 26.04 3.48 10.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "3.48 54.77 3.48 39.5 27.08 39.5 3.48 54.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "93.12 54.77 93.12 39.5 69.51 39.5 93.12 54.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "gbflag-cls-4",
    points: "93.12 10.61 93.12 25.88 69.51 25.88 93.12 10.61"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGbFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GBFlag.9ba4635d.svg";
export { ForwardRef as ReactComponent };